import debug from 'debug';
import { Base } from '../base-behaviour';

const log = debug('fus078/components/file-upload-field');

export class fileUploader extends Base {

	constructor(element, options) {
		super(element, options);

		this.$dropzone = this.$element.find(this.options.dropzoneselector);
		this.$input = this.$element.find(this.options.inputfieldselector);
		System.import(
			/* webpackChunkName: "vendor/jquery.fineuploader@3.5.0" */
			'@vendor/jquery.fineuploader@3.5.0'
		).then(this.init.bind(this));
		log('constructed', this.element);
	}

	init() {
		this.$dropzone.fineUploader({
			request: {
				endpoint: this.options.endpoint,
				customHeaders: { Accept: 'application/json' }
			},
			debug: false,
			multiple: false,
			button: this.$element,
			validation: {
				allowedExtensions: this.options.allowedextensions.split(','),
				sizeLimit: this.options.sizelimit
			},
			showMessage: this.showMessage.bind(this)
		})
			.on('submit', this.onSubmit.bind(this))
			.on('complete', this.onComplete.bind(this))
			.on('error', this.onError.bind(this));
		log('fineUploader.bound', this.$dropzone);
	}

	onError(event, id, name, errorReason, xhrOrXdr) {
		log('error', {el: this.element, id, name, errorReason});
		this.$dropzone
			.empty()
			.append('An error occurred uploading your file: ' + errorReason);
	}

	showMessage(message) {
		log('showMessage', { el: this.element, message });
		this.$dropzone
			.empty()
			.append('An error occurred uploading your file: ' + message);
	}

	onComplete(event, id, fileName, responseJSON) {
		log('onComplete', { el: this.element, id, fileName, responseJSON});
		this.$dropzone.empty();
		if (responseJSON.success) {
			var filename = responseJSON.Filename;
			if (filename !== "") {
				var origFilename = responseJSON.Description;
				this.$dropzone.find(".qq-upload-list").empty();
				this.$dropzone.empty().append(origFilename);
				this.$input.val(filename);
			}
			this.$input.trigger('blur');
		}
	}

	onSubmit() {
		log('onSubmit', { el: this.element });
		this.$dropzone.empty().append('Uploading...');
	}

}

fileUploader.componentName = 'fileuploader';

fileUploader.DEFAULTS = {
	dropzoneselector: '[data-fileuploader-dropzone]',
	inputfieldselector: '[data-fileuploader-input]',
	allowedextensions: 'zip,doc,docx,pdf',
	endpoint: '/',
	sizelimit: 4 * 1024 * 1024
};


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/file-upload-field/component.js